import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Grid } from 'semantic-ui-react';

import { Frame, VBarChart, HLineChart, HBarChart, LabeledPieChart } from 'components/DashBoard';
import { LoadingBar } from 'components/Commons';

import * as dashAction from 'actions/dashboard';
import cm from 'helpers/commons';
import menuList from 'config/menuList';
import { safeHistoryPush } from 'helpers/pathValidator';

moment.tz.setDefault('Asia/Seoul');

class DashBoard extends Component {
  constructor() {
    super();

    this.state = {
      loading: true
    };
  }

  componentWillMount() {
    setTimeout(async () => {
      await this.statistics('all');

      this.setState({
        loading: false
      });

      const { company } = this.props;
      const { state } = this.context.router.route.location; // link 클릭으로 진입시 parameter
      let comInfo = null;
      let url = null;
      let auth = null;
      let isApproval = false;

      if (company && company.data) {
        auth = company.data.auth.auth;
        comInfo = company.data.user.company;
        isApproval = company.data.user.isApproval;
        // link 진입시
        // if (state) {
        //   url = `/main/${state.type}`;
        // }
        menuList.depth1.some((data) => {
          if (url) {
            return true;
          }
          url = cm.isMenuView(data, auth);
        });
      }
      if (url !== '/main/dashBoard') {
        if (!auth && isApproval && comInfo.isInvoice) {
          url = '/main/bill';
        }
        try {
          safeHistoryPush(this.context.router.history, {
            pathname: url,
            search: '',
            state
          });
        } catch (e) {
          console.log('###### e : ', e);
        }
      }
    }, 2000);
  }

  statistics = (type, data) => {
    try {
      const { dashAPI } = this.props;

      switch (type) {
        case 'all':
          dashAPI.monthlyStatus();
          dashAPI.dailyStatus();
          dashAPI.hourlyStatus({ type: 'T' });
          dashAPI.storeTopList();
          dashAPI.departmentTopList();
          dashAPI.menuTopList();
          break;

        case 'hourlyList':
          dashAPI.hourlyStatus({ type: data });
          break;

        default:
      }
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { monthly, daily, hourly, store, department, menu } = this.props;
    const { loading } = this.state;

    let monthlyData = [];
    let dailyData = [];
    const hourlyData = {
      type: 'T',
      date: cm.yyyyMMdd(new Date(moment())),
      data: null,
      legend: [],
      isMaxWidth: false
    };
    const storeData = {
      date: cm.yyyyMMdd(new Date(moment())),
      data: [],
      isMaxWidth: true
    };
    const departmentData = {
      date: cm.yyyyMMdd(new Date(moment())),
      data: null,
      isMaxWidth: true
    };
    const menuData = {
      date: cm.yyyyMMdd(new Date(moment())),
      data: [],
      isMaxWidth: true
    };

    if (monthly && daily && hourly && store && department && menu) {
      // loading = null
    }

    if (monthly) {
      if (monthly.data) {
        const { data } = monthly;
        monthlyData = data.stat ? data.stat.map((item) => ({ name: item.month, 식대금액: item.salesprice })) : null;
      }
    }

    if (daily) {
      if (daily.data) {
        const { data } = daily;
        dailyData = data.stat
          ? data.stat.map((item) => ({
              name: cm.mmDD(new Date(item.day)),
              식대금액: item.salesprice
            }))
          : null;
      }
    }

    if (hourly) {
      if (hourly.data) {
        const { data } = hourly;
        hourlyData.type = data.type;
        hourlyData.legend = [
          { value: '금액별', type: 'square', color: '#82ca9d' },
          { value: '사용자별', type: 'square', color: '#ECB632' }
        ];
        hourlyData.date = data.date
          ? `${cm.yyyyMMdd(new Date(data.date.start))} ~ ${cm.yyyyMMdd(new Date(data.date.end))}`
          : cm.yyyyMMdd(new Date(moment()));
        if (data.stat) {
          hourlyData.data = [];
          let k = 0;

          for (let i = 0; i < data.stat.length; i++) {
            const time = parseInt(data.stat[i].time);
            for (let j = k; j <= time; j++) {
              if (time !== j) {
                hourlyData.data.push({ name: j, 식대금액: 0, 사용자별: 0 });
              } else {
                hourlyData.data.push({
                  name: time,
                  식대금액: data.stat[i].salesprice,
                  사용자별: data.stat[i].mcount
                });
              }
            }
            k = time + 1;
          }
          for (k; k < 25; k++) {
            hourlyData.data.push({ name: k, 식대금액: 0, 사용자별: 0 });
          }
        } else {
          // for(let i=0; i<25; i++) {
          // hourlyData.data.push({ name: i, 식대금액 : 0, count: 0 });
          hourlyData.data = null;
          // }
        }
      }
    }

    if (store) {
      if (store.data) {
        const { data } = store;
        const colors = ['#5484C1', '#52ABD1', '#4BB496', '#A0CB6C', '#F3D64C', '#9F8FC2'];

        storeData.date = data.date
          ? `${cm.yyyyMMdd(new Date(data.date.start))} ~ ${cm.yyyyMMdd(new Date(data.date.end))}`
          : moment().format('LLL');

        storeData.data = data.stat
          ? data.stat.map((item, idx) => {
              const name = cm.textNowrap(item.storename, 15, 12);
              if (!storeData.isMaxWidth) {
                storeData.isMaxWidth = item.storename.length >= 15;
              }
              const obj = {
                name,
                '이번달 식대금액': item.price.now,
                식대금액PIE: item.price.now,
                '지난달 식대금액': item.price.pre,
                color: colors[idx]
              };
              return obj;
            })
          : null;
      }
    }

    if (department) {
      if (department.data) {
        const { data } = department;
        departmentData.date = data.date
          ? `${cm.yyyyMMdd(new Date(data.date.start))} ~ ${cm.yyyyMMdd(new Date(data.date.end))}`
          : cm.yyyyMMdd(new Date(moment()));
        departmentData.data = data.stat
          ? data.stat.map((item) => {
              const name = cm.textNowrap(item.division, 15, 12);
              // let name = item.division;
              const obj = {
                name,
                '이번달 식대금액': item.price.now,
                '지난달 식대금액': item.price.pre
              };

              return obj;
            })
          : null;
      }
    }

    if (menu) {
      if (menu.data) {
        const { data } = menu;
        const colors = ['#5484C1', '#52ABD1', '#4BB496', '#A0CB6C', '#F3D64C', '#9F8FC2'];

        menuData.date = data.date
          ? `${cm.yyyyMMdd(new Date(data.date.start))} ~ ${cm.yyyyMMdd(new Date(data.date.end))}`
          : cm.yyyyMMdd(new Date(moment()));
        menuData.data = data.stat
          ? data.stat.map((item, idx) => {
              const name = `${item.storename} ${item.menu.name}`;
              // name = cm.textNowrap(name, 15, 15);
              const obj = {
                name,
                subname: item.storename,
                '이번달 식대금액': item.menu.price,
                color: colors[idx]
              };
              return obj;
            })
          : null;
      }
    }

    return (
      <main id="dashboard">
        {loading ? (
          <LoadingBar />
        ) : (
          <Grid columns="equal">
            <Grid.Row>
              <Grid.Column>
                <div className="dash-half">
                  <Frame width={568} title="월별 식대 금액">
                    <VBarChart width={568} height={258} data={monthlyData} />
                  </Frame>
                </div>
                <div className="dash-half">
                  <Frame width={568} title="일별 식대 금액">
                    <HLineChart width={568} height={258} data={dailyData} />
                  </Frame>
                </div>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <Frame
                  width={1152}
                  type={hourlyData.type}
                  date={hourlyData.date}
                  periodSel={this.statistics}
                  title="시간대별 사용 현황"
                >
                  <HLineChart width={1100} height={258} data={hourlyData.data} legend={hourlyData.legend} />
                </Frame>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                {storeData.data ? (
                  <Frame width={1152} date={storeData.date} title="가맹점 사용금액 TOP 5">
                    <HBarChart width={650} height={258} data={storeData.data} isMaxWidth={storeData.isMaxWidth} />
                    <LabeledPieChart width={450} height={258} data={storeData.data} />
                  </Frame>
                ) : (
                  <Frame width={1152} date={storeData.date} title="가맹점 사용금액 TOP 5">
                    <HBarChart width={1100} height={258} data={storeData.data} />
                  </Frame>
                )}
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <Frame width={1152} date={departmentData.date} title="부서 사용금액 TOP 5">
                  <HBarChart
                    width={1100}
                    height={258}
                    isMaxWidth={departmentData.isMaxWidth}
                    data={departmentData.data}
                  />
                </Frame>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <Frame width={1152} date={menuData.date} title="메뉴 TOP 5">
                  <HBarChart width={1100} height={258} data={menuData.data} isMaxWidth={menuData.isMaxWidth} />
                </Frame>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )}
        {/* <div className="innertube">
          <h1>Headding</h1>
        </div> */}
      </main>
    );
  }
}

DashBoard.contextTypes = {
  router: PropTypes.object.isRequired
};

DashBoard = connect(
  (state) => ({
    monthly: state.dashboard.monthly,
    daily: state.dashboard.daily,
    hourly: state.dashboard.hourly,
    store: state.dashboard.storeTop,
    department: state.dashboard.departmentTop,
    menu: state.dashboard.menuTop,
    company: state.auth.company
  }),
  (dispatch) => ({
    dashAPI: bindActionCreators(
      {
        monthlyStatus: dashAction.MonthlyStatus,
        dailyStatus: dashAction.DailyStatus,
        hourlyStatus: dashAction.HourlyStatus,
        storeTopList: dashAction.StoreTopList,
        departmentTopList: dashAction.DepartmentTopList,
        menuTopList: dashAction.MenuTopList
      },
      dispatch
    )
  })
)(DashBoard);

export default DashBoard;
